import React from 'react';
import PropTypes from 'prop-types';

import Article from './Article';


class Articles extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { articles } = this.props;

    return (
      <React.Fragment>
        { articles.map((article) => (
          <Article key={article.id} article={article} />
        ))
        }
      </React.Fragment>
    );
  }
}

export default Articles;
